// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__We-06","header":"MessagesList_header__3AZGD","chat":"MessagesList_chat__2Ro9o"};